export default "__VITE_ASSET__JnmsWvPs__"